<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        head: {
			title: { inner: 'Track your tennis stats and performance', separator: '|', complement: 'Str8 Sets' },
            meta: [
				{ name: 'description', content: 'Have greater insight into your tennis performance by viewing your player profile. Win/loss, match result breakdown, head-to-head and more directly on the Str8 Sets app. You can even view the profile of other players in your Circle. See how you match up against others with Str8 Sets!', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_player_profile' },
                { property: 'og:title', content: 'Track your tennis stats and performance | Str8 Sets' },
                { property: 'og:description', content: 'Have greater insight into your tennis performance by viewing your player profile. Win/loss, match result breakdown, head-to-head and more directly on the Str8 Sets app. You can even view the profile of other players in your Circle. See how you match up against others with Str8 Sets!' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_blue_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_player_profile' },
				{ name: 'twitter:title', content: 'Track your tennis stats and performance | Str8 Sets' },
                { name: 'twitter:description', content: 'Have greater insight into your tennis performance by viewing your player profile. Win/loss, match result breakdown, head-to-head and more directly on the Str8 Sets app. You can even view the profile of other players in your Circle. See how you match up against others with Str8 Sets!' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_blue_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_player_profile', id: 'canonical' }
			]
        }
    })
</script>

<template>
    <div>
    
        <div class="parallax parallax image-green-courts-above height-350">
            <div class="container">
                <div class="feature-page-header">
                    <h1>Player Profile</h1>
                    <h2>We all deserve one</h2>
                </div>
                <div class="row">
                    <router-link class="clear_button" to="/faq#profile" role="button">FREQUENT QUESTIONS</router-link>
                </div>
            </div>
        </div> 

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>If you love tennis- you take it seriously regardless of your skill level. You don't need to be 
                            Roger Federer to keep track of your stats and performance, we should all be able to do that! This is why 
                            we created the Profile screen for every player on Str8 Sets. It <strong>gives you insights about your performance 
                            and how you measure up against players in your Circle</strong>.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 heading">
                        <img class="icon" src="@/assets/images/trophy-green-circle.svg" alt="Green Trophy Icon" data-no-retina>
                        <h2>How it Works</h2>
                        <h4>Monitoring performance!</h4>
                    </div>                            
                </div>
                <div class="row">                               
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>The Profile view provides you with overall win/loss ratios for your singles and doubles matches. It also gives you a breakdown 
                            of those numbers by surface and for recent form, you get to see a win/loss ratio over the past few matches.</p>
                            
                            <p>You can even view the profile of other players within your Circle. You can view your overall head-to-head record or have 
                            it broken down by surface and match format. And it gets better, if you played that person, you can anonymously rate their 
                            skills and help them improve by seeing how others assess their different skills. So why not give your friends a hand and 
                            give them feedback via the Str8 Sets app.</p>
                            
                            <p>The Profile screen is a comprehensive look at your form based on matches (approved by both sides) that are 
                            listed on Str8 Sets. The more matches you record (approved by your opponent) the better it gets!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row text-center">
                    <img class="img_inrow" :src="'/img/iphone_circle_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Circle)" v-rjs="2">
                    <img class="img_inrow" :src="'/img/iphone_playerprofile_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Player Profile)" v-rjs="2">
                </div> 
            </div>
        </section>

        <div class="parallax parallax image-green-courts-above height-150" ></div>

        <div class="spacer-large"></div>

    </div>
</template>